import React from 'react';
import { colors } from '@styleseat/brand';

type MegaPhoneIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const MegaPhoneIcon = ({
  width = 24,
  height = 24,
  color = colors.ash,
}: MegaPhoneIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M21 10C21 10.67 21 11.33 21 12C22.2 12 23.76 12 25 12C25 11.33 25 10.67 25 10C23.76 10 22.2 10 21 10Z"
        fill={color}
      />
      <path d="M19 16.61C19.96 17.32 21.21 18.26 22.2 19C22.6 18.47 23 17.93 23.4 17.4C22.41 16.66 21.16 15.72 20.2 15C19.8 15.54 19.4 16.08 19 16.61Z" fill={color} />
      <path d="M23.4 4.6C23 4.07 22.6 3.53 22.2 3C21.21 3.74 19.96 4.68 19 5.4C19.4 5.93 19.8 6.47 20.2 7C21.16 6.28 22.41 5.35 23.4 4.6Z" fill={color} />
      <path fillRule="evenodd" clipRule="evenodd" d="M6.44101 21.15V14.4193H4.72737C3.40671 14.4193 2.3501 13.3854 2.3501 12.1539V9.5385C2.3501 8.30701 3.40671 7.27311 4.72737 7.27311H10.2754L16.6501 3.60522V18.0872L10.2754 14.4193H8.46828V21.15H6.44101ZM14.6228 7.01152L11.4121 8.85577L10.8378 9.1885H4.37737V12.5039H10.8379L11.411 12.836L14.6228 14.6809V7.01152Z" fill={color} />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
